import { QESButton } from "@app/shared/qes-standards/Button";
import { FC, useContext } from "react";
import { ReportCustomizationContext } from "../ReportCustomizationContext";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface GenerateSectionProps {
  settingsAreValid?: boolean;
  onGenerate: () => void;
}

export const GenerateSection: FC<GenerateSectionProps> = (props: GenerateSectionProps) => {
  const rcContext = useContext(ReportCustomizationContext);

  return (
    <div className="container-fluid ml-0">
      <div className="row justify-content-end">
        <QESButton
          qesType="primary"
          qesTestId="report-customization__primary"
          onClick={props.onGenerate}
          disabled={rcContext.state.isGenerating || !props.settingsAreValid}
        >
          Generate {rcContext.state.isGenerating && <QesIcon iconName={QesIcons.FontAwesome.Spinner} classNames="qes-icon-spin" />}
        </QESButton>
      </div>
    </div>
  )
}